"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var React = require("react");
var react_tiny_popover_1 = require("react-tiny-popover");
var UserTimeline_1 = require("../../../../model/UserTimeline");
var Timeline_1 = require("./Timeline");
var PopoverTimeline = /** @class */ (function (_super) {
    __extends(PopoverTimeline, _super);
    function PopoverTimeline(props) {
        return _super.call(this, props) || this;
    }
    PopoverTimeline.prototype.render = function () {
        var _this = this;
        var dayTimelines = this.props.timelines
            .filter(function (timeline) { return timeline.type === UserTimeline_1.IUserTimelineType[_this.props.type]; })
            .map(function (timeline, index, _a) {
            var _b, _c;
            var length = _a.length;
            var typeConfig = UserTimeline_1.timelineTypeConfigs.find(function (_a) {
                var type = _a.type;
                return type === _this.props.type;
            });
            var statusConfig = ((_b = typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.status) === null || _b === void 0 ? void 0 : _b[timeline.status]) || null;
            var labelText = '';
            if (_this.props.type === UserTimeline_1.IUserTimelineType.WORK_STATE) {
                labelText = ((_c = timeline === null || timeline === void 0 ? void 0 : timeline.notes) === null || _c === void 0 ? void 0 : _c.isManualToggle) ? 'Handmatig' : 'Automatisch';
            }
            return React.createElement(Timeline_1.default, { index: index, key: "timeline--".concat(index), type: _this.props.type.toLowerCase(), time: moment(timeline.createdAt).format('H:mm'), lineClass: index + 1 === length ? '' : 'icon-line', title: (statusConfig === null || statusConfig === void 0 ? void 0 : statusConfig.text) || '', icon: (statusConfig === null || statusConfig === void 0 ? void 0 : statusConfig.icon) || '', titleClass: (statusConfig === null || statusConfig === void 0 ? void 0 : statusConfig.titleClass) || '', label: labelText });
        });
        if (!dayTimelines.length) {
            return null;
        }
        return (React.createElement(react_tiny_popover_1.Popover, { isOpen: this.props.isPopoverOpen, positions: ['bottom'], containerClassName: "react-tiny-popover-container with-timeline", onClickOutside: this.props.onClickOutside, content: function (_a) {
                var position = _a.position, childRect = _a.childRect, popoverRect = _a.popoverRect;
                return (React.createElement(react_tiny_popover_1.ArrowContainer, { position: position, childRect: childRect, popoverRect: popoverRect, arrowColor: "#fff", arrowSize: 10, arrowStyle: { opacity: 1 }, className: "popover-arrow-container", arrowClassName: "popover-arrow" },
                    React.createElement("div", { style: { maxHeight: '250px', overflowY: 'auto' } }, dayTimelines)));
            } },
            React.createElement("span", { className: this.props.anchorClass, onClick: this.props.onClickAnchor }, this.props.anchorText || (this.props.isPopoverOpen ? 'Verbergen' : 'Show'))));
    };
    return PopoverTimeline;
}(React.Component));
exports.default = PopoverTimeline;
